export default function AgendaItemCommentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  oversightDataService,
  oversightSharedModelService,
  confirmDialog,
  docDataService,
  editFindingCommentDialog,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Agenda Item Note Added';
  vm.isExpanded = false;
  // vm.canEditItem = vm.canEdit;
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleDeleteAgendaItemComment = _handleDeleteAgendaItemComment;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleDeleteAgendaItemComment($event) {
    ssDialogService.dialogs.oversight.deleteAgendaItemCommentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Note?',
        message: `Are you sure you want to delete this note "${vm.agendaItemCommentDetail.text}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.oversight.deleteAgendaItemCommentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return oversightDataService.deleteAgendaItemComment(vm.agendaItemCommentDetail.agendaItemCommentId)
      .then(() => {
        alerts.success('The Agenda Item Note has been deleted successfully.');
        $rootScope.$broadcast('refreshAgendaItemComments', { agendaItemId: vm.agendaItemId });
        $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Note.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.oversight.deleteAgendaItemCommentConfirmDialog);
  }
}

AgendaItemCommentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'oversightDataService',
  'oversightSharedModelService',
  'confirmDialog',
  'docDataService',
  'editFindingCommentDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
